import React from "react";
import Barcode from "react-barcode";

export default function BarcodeSVG({
  value,
  format = "CODE128",
  width = 2.5,
  height = 100,
  displayValue = true,
  fontSize = 35,
  fontOptions = "bold",
}) {
  return (
    <Barcode
      value={value}
      format={format}
      width={width}
      height={height}
      displayValue={displayValue}
      fontSize={fontSize}
      fontOptions={fontOptions}
    />
  );
}
